export function formatPhoneNumber(tel: string) {
  if (tel.length === 10) {
    return `(${tel.substring(0, 3)}) ${tel.substring(3, 6)}-${tel.substring(6)}`;
  }
  return tel;
}